import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {CheckCredentialsRequest, CheckCredentialsResponse} from './types'

export interface CheckCredentials<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const checkCredentials: CheckCredentials<
  CheckCredentialsRequest,
  CheckCredentialsResponse
> = (http, params) => {
  const {ClientID} = params

  const path = '/v1/eztexting/credentials/check'

  const queryParams = []
  if (ClientID !== undefined) {
    queryParams.push(`clientid=${ClientID}`)
  }
  const query = `?${queryParams.join('&')}`

  return http.request<CheckCredentialsResponse>({
    method: 'POST',
    url: `${path}${query}`,
  })
}
